import { ProbetrainingWidget } from "../components/probetraining"
export const Probetraining = () => {
    return(
        <div className="grid place-items-center my-8 mx-10 md:mx-20 lg:mx-80 ">
            <ProbetrainingWidget/>
        </div>
    )
}